import { render, staticRenderFns } from "./create-sender.vue?vue&type=template&id=053ae2fe"
import script from "./create-sender.vue?vue&type=script&lang=ts"
export * from "./create-sender.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports